import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { numberAsCurrency } from '../../utils/index';
import Lottie from 'lottie-react';
import confettiAnimation from '../../../animations/confetti.json';

const TROPHY_URL = 'https://d2zdlj1ifv8u1d.cloudfront.net/images/trophy.svg';

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: '14px',
    border: '1px solid #CFEBD0',
    backgroundColor: '#EEF4FF',
    padding: '14px 14px',
    marginBottom: '14px',
    textAlign: 'center',
    position: 'relative',
    overflow: 'hidden',
    zIndex: 0,
  },
  confetti: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    pointerEvents: 'none',
    zIndex: 1,
    opacity: 0.9,
  },
  content: {
    position: 'relative',
    zIndex: 2,
  },
  trophy: {
    width: '40px',
    height: '40px',
    display: 'inline-block',
    marginBottom: '6px',
  },
  title: {
    color: '#1A1A1A',
    lineHeight: 1.3,
    marginBottom: '6px',
    '&&': {
      fontSize: '0.92rem',
    },
    '& strong': {
      fontWeight: 800,
    },
  },
  prizeValue: {
    color: '#3B7E3D',
    fontSize: '1.1rem',
    lineHeight: 1.1,
    fontWeight: 800,
    marginBottom: '8px',
  },
  label: {
    color: '#2B692D',
    fontWeight: 700,
    fontSize: '0.86rem',
    marginBottom: '6px',
  },
  numberBox: {
    margin: '0 auto 10px',
    maxWidth: '180px',
    backgroundColor: '#275E28',
    color: '#FFFFFF',
    borderRadius: '7px',
    padding: '8px 10px',
    fontWeight: 900,
    fontSize: '1.25rem',
    lineHeight: 1,
    letterSpacing: '0.02em',
  },
  cta: {
    display: 'inline-block',
    backgroundColor: '#3B7E3D',
    color: '#FFFFFF',
    textDecoration: 'none',
    borderRadius: '7px',
    padding: '8px 16px',
    fontSize: '0.82rem',
    fontWeight: 700,
    '&:hover': {
      backgroundColor: '#316832',
    },
  },
}));

export default function OrderInstantPrizePanel({ order, influencerUsername }) {
  const classes = useStyles();
  const instantPrize = order?.instant_prizes?.[0];
  if (!instantPrize) return null;

  const withdrawalPath = influencerUsername
    ? `/${influencerUsername}/site/withdrawal`
    : '/site/withdrawal';

  return (
    <div className={classes.root}>
      <Lottie className={classes.confetti} animationData={confettiAnimation} />
      <div className={classes.content}>
        <img src={TROPHY_URL} alt="" className={classes.trophy} />
        <Typography component="div" className={classes.title}>
          Parabéns!{' '}
          <strong>
            Você acabou de ganhar
            <br />
            um prêmio instantâneo de
          </strong>
        </Typography>
        <div className={classes.prizeValue}>{numberAsCurrency(instantPrize.instant_prize_value)}</div>
        <div className={classes.label}>Seu número de sorte:</div>
        <div className={classes.numberBox}>{instantPrize.pretty_number}</div>
        <a href={withdrawalPath} className={classes.cta}>
          Saque agora seu prêmio
        </a>
      </div>
    </div>
  );
}
